import { createRoute } from '@tanstack/react-router'
import { t } from 'i18next'

import { DynamicRouteParameterWPrefix } from 'config/routing'
import { Overview } from 'domains/MediaPlatforms/Events/Event'
import { mediaPlatformEventsRoute } from 'pages/NWPlatform/MediaPlatforms/MediaPlatform/Events'
import { Structure } from 'pages/NWPlatform/MediaPlatforms/MediaPlatform/Events/Event'

export const mediaPlatformEventRoute = createRoute({
  getParentRoute: () => mediaPlatformEventsRoute,
  path: DynamicRouteParameterWPrefix.EVENT_ID,
  loader: () => ({
    crumb: t('entity:publishing.event', { count: 1 }),
  }),
})

export const mediaPlatformEventLayoutRoute = createRoute({
  getParentRoute: () => mediaPlatformEventRoute,
  id: 'mediaPlatformEventLayout',
  component: Structure,
})

export const mediaPlatformEventRawRoute = createRoute({
  getParentRoute: () => mediaPlatformEventLayoutRoute,
  path: '/',
  component: Overview,
})
